import toast from "react-hot-toast";
import { put, select, takeEvery } from "redux-saga/effects";
import { USER_ROLES } from "../../components/utils/enums";
import { createUserServ, deleteUserServ, getServedUserServ, getUserServ, updateUserServ } from "../services/user.service";
import { userActions } from "../slice/user.slice";
import { CREATE_USER, DELETE_USER, GET_SERVED_USERS, GET_USERS, UPDATE_USER } from "../types/user.types";

// Which list in the store holds users of a given role
const listForRole = (role) => {
    switch (role) {
        case USER_ROLES.S_ADMIN: return { selector: userActions.selectors.getSuperAdmins, setter: userActions.actions.setSuperAdminsSlice };
        case USER_ROLES.TRUSTEE: return { selector: userActions.selectors.getTrustees, setter: userActions.actions.setTrusteesSlice };
        default: return { selector: userActions.selectors.getVolunteers, setter: userActions.actions.setVolunteersSlice };
    }
};

export function* createUserSaga(action) {
    try {
        const user = yield createUserServ(action.payload);

        if (user?.data) {
            const { selector, setter } = listForRole(user?.data?.role);
            const prev = yield select(selector);
            yield put(setter([user?.data, ...(prev || [])]));

            toast.success("User Created successful");
        } else {
            toast.error(user?.message || "Something Went Wrong");
        }
    } catch (err) {
        toast.error(err?.response?.data?.message || "Something Went Wrong");
    }
}

export function* getUserSaga(action) {
    try {
        const users = yield getUserServ(action.payload);
        const userData = users?.data || [];

        yield put(listForRole(action.payload.role).setter(userData));
    } catch (err) {
        console.log("Error fetching users:", err?.message);
    }
}

export function* getServedUserSaga(action) {
    try {
        const users = yield getServedUserServ(action.payload);
        console.log("user", users)
        yield put(userActions.actions.setServedUsersSlice(users?.data));
    } catch (err) {
        console.log("Error fetching users:", err?.message);
    }
}


export function* deleteUserSaga(action) {
    try {
        const user = yield deleteUserServ(action.payload?.userId);
        if (user?.data) {
            toast.success("User Deleted Successfully");
            const { selector, setter } = listForRole(user?.data?.role);
            const prev = yield select(selector);
            yield put(setter((prev || []).filter(u => u._id !== user.data._id)));
        } else {
            toast.error(user?.message || "Something Went Wrong");
        }

    } catch (err) {
        toast.error(err?.response?.data?.message || "Something Went Wrong");
    }
}

export function* updateUserSaga(action) {
    try {
        const updatedUser = yield updateUserServ(action.payload);
        console.log("updated", updatedUser);
        if (updatedUser?.data) {
            const { selector, setter } = listForRole(updatedUser?.data?.role);
            const prev = yield select(selector);
            yield put(setter((prev || []).map(u => u._id === updatedUser.data._id ? updatedUser.data : u)));

            toast.success("User updated successfully");
        } else {
            toast.error("Something went wrong");
        }
    } catch (err) {
        toast.error("Something went wrong");
    }
}


export function* watchUserAsync() {
    yield takeEvery(CREATE_USER, createUserSaga);
    yield takeEvery(GET_USERS, getUserSaga);
    yield takeEvery(DELETE_USER, deleteUserSaga);
    yield takeEvery(UPDATE_USER, updateUserSaga);
    yield takeEvery(GET_SERVED_USERS, getServedUserSaga);
}
